


























































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class TableHeader extends Vue {
  @Prop() readonly sort!: (sortOrder: string, sortBy: string) => void;
  @Prop({ type: String }) readonly fieldToSortBy!: string;
  @Prop({ type: String }) readonly title!: string;
  @Prop({ type: String }) readonly sortOrder!: string;
  @Prop({ type: String }) readonly sortBy!: string;
  @Prop({ type: String, default: "all" }) readonly status!: string;
}
